// packages/shared-hooks/src/lead-tasks/useCancelledLeadTasks.ts
//
// `GET /lead-tasks/cancelled?leadId=<uuid>` (#2317 D-3a) — the SOFT-CANCELLED
// MANUAL tasks on one lead the actor can reopen (own for a manager, all for
// admin), ordered most-recently cancelled first. A SEPARATE wire contract from
// the open-task list (`GetCancelledLeadTasksResponse` carries a non-null
// `cancelledAt`); `enabled` keeps it dormant until the card gate opts in.
import { useQuery } from '@tanstack/react-query';
import {
  GetCancelledLeadTasksResponseSchema,
  type GetCancelledLeadTasksResponse,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadTasksKeys } from './keys.js';

export interface UseCancelledLeadTasksOptions {
  /** Disable until the card editability gate is resolved (#2317). */
  enabled?: boolean;
}

export function useCancelledLeadTasks(leadId: string, options: UseCancelledLeadTasksOptions = {}) {
  const client = useApiClient();
  return useQuery<GetCancelledLeadTasksResponse>({
    queryKey: leadTasksKeys.cancelledByLead(leadId),
    enabled: options.enabled ?? true,
    queryFn: ({ signal }) =>
      client.get<GetCancelledLeadTasksResponse>(
        '/lead-tasks/cancelled',
        { signal, query: { leadId } },
        GetCancelledLeadTasksResponseSchema,
      ),
  });
}
